const WRONG_USER_PASSWORD = 'Email y contraseña no coinciden';
const UNKNOWN_ERROR = 'Ha ocurrido un error, intente más tarde';

export {
  WRONG_USER_PASSWORD,
  UNKNOWN_ERROR,
};
